import React from "react";
import { Link } from "react-router-dom";
import { FRONTEND_LINKS } from "../../Constants/FrontendLinks";
import { MobergFontFamily } from "../../Components/MobergFont/MobergFont";
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import styled from "styled-components";
import bgImg from "../Account/Login/bgImg.png";
import darkLogoImg from "../Account/Login/moberg-logo-dark.png";
import lightLogoImg from "../Account/Login/moberg-logo-light.png"
import { useMobergTheme } from "../../Providers/MobergThemeProvider"

export default function InactivityPage(props) {
    const { colorScheme } = useMobergTheme()
    const logoImg = colorScheme === "dark" ? lightLogoImg : darkLogoImg

    return (
        <Container>
            <CenteredBox>
                <ErrorBox>
                    <TopSection>
                        <img src={logoImg} alt="Moberg Analytics" style={{ width: '90px', marginBottom: '16px' }} />
                        <Title>Session Timeout</Title>
                    </TopSection>
                    <CenterSection>
                        <IconWrapper>
                            <RunningWithErrorsIcon style={{ fontSize: 64, color: 'var(--color-accent-interactive)' }} />
                        </IconWrapper>
                        <Subtitle>You have been logged out due to inactivity.</Subtitle>
                    </CenterSection>
                    <BottomSection>
                        <LoginLink to={FRONTEND_LINKS.MAIN} onClick={() => props.setNavPage(true)}>
                            Back to sign in
                        </LoginLink>
                    </BottomSection>
                </ErrorBox>
            </CenteredBox>
        </Container>
    );
}

const Container = styled.div`
    background-image: url(${bgImg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: var(--color-surface-primary);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0);
        [data-color-scheme="dark"] & {
            background: rgba(0, 0, 0, 0.75);
        }
    }

    & > * {
        position: relative;
        z-index: 1;
    }
`;

const CenteredBox = styled.div`
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    justify-self: center;
    height: auto;
    width: 100%;
    max-width: 450px;
    min-width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    left: 0;
    top: 0;

    @media (max-width: 768px) {
        width: 90%;
        min-width: 280px;
        max-width: 400px;
    }

    @media (max-width: 480px) {
        width: 95%;
        min-width: 260px;
        max-width: 350px;
        padding: 0 10px;
    }
`;

const ErrorBox = styled.div`
    box-shadow: var(--modal-box-shadow);
    background: var(--color-surface-panel);
    border-radius: 4px;
    min-width: 400px;
    padding: 48px 32px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    @media (max-width: 600px) {
        align-items: center;
        padding-top: 0;
        padding-bottom: 16px;
    }
`;

const CenterSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 0;
    text-align: center;
    gap: 16px;
`;

const BottomSection = styled.div`
    width: 100%;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    @media (max-width: 600px) {
        padding-bottom: 32px;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h1`
    font-family: ${MobergFontFamily.HEADER};
    font-weight: 700;
    margin: 0;
    letter-spacing: 1px;
    font-size: 28px;
    color: var(--color-text-primary);
    text-align: center;
`;

const Subtitle = styled.p`
    font-family: ${MobergFontFamily.REGULAR};
    color: var(--text-secondary-color);
    margin: 0;
    font-size: 16px;
    line-height: 1.6;
    max-width: 320px;
    text-align: center;
`;

const LoginLink = styled(Link)`
    width: 100%;
    padding: 12px 0;
    background: var(--color-accent-interactive);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    font-family: ${MobergFontFamily.HEADER};
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    transition: filter 0.2s;

    [data-color-scheme="dark"] & {
        background: #207DEA;
    }

    &:hover {
        filter: brightness(0.85);
        text-decoration: none;
        color: #fff;
    }
`;